// extracted by mini-css-extract-plugin
module.exports = {"text":"Paragraph_text__1_V0m","faint":"Paragraph_faint__1fnJj","small":"Paragraph_small__nw131"};